import { usePrincipalKey } from "@auth/sessionStore";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";

import { fetchInbox, fetchQuestion } from "./questionsClient";

export const questionKeys = {
  all: (principal: string) => ["questions", principal] as const,
  inbox: (principal: string) => ["questions", principal, "inbox"] as const,
  detail: (principal: string, id: string) =>
    ["questions", principal, id] as const,
};

export function useQuestionInbox() {
  const principal = usePrincipalKey();
  return useInfiniteQuery({
    queryKey: questionKeys.inbox(principal),
    queryFn: ({ pageParam }) => fetchInbox(pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (page) => page.after ?? undefined,
    refetchInterval: 15_000,
  });
}

export function useQuestion(id: string) {
  const principal = usePrincipalKey();
  return useQuery({
    queryKey: questionKeys.detail(principal, id),
    queryFn: () => fetchQuestion(id),
    refetchInterval: 10_000,
  });
}
